import React from "react";
import Login from "../../Pages/Public/Login";
import { Route, Routes, Navigate } from "react-router-dom";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default PublicRoutes;
